import { FollowCountsInterface } from '../../..';

export class FollowCountsDto implements FollowCountsInterface {
  followCount: number;
  followerCount: number;
  followId?: string;
  isCurrentUserFollowing?: boolean;
}
